import PromptDialogComponent from "./PromptDialog";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import vuetify from "@/plugins/vuetify";

const promptDialogOptions = {
  type: "text",
  label: "",
  placeholder: "",
  required: true,
};

export default function PromptDialog(
  title = "",
  text = "",
  options = promptDialogOptions
) {
  return new Promise((resolve) => {
    let propsData = {
      visible: true,
      title,
      text,
      options,
      confirm: resolve,
      cancel: resolve,
    };
    Vue.use(Vuetify);
    const cd = Vue.extend(PromptDialogComponent);
    this.component = new cd({
      el: document.createElement("div"),
      vuetify,
      propsData,
    });
  }).then(() => this.component.val);
}
